import CartItems from './CartItems';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';


const formatNumber = (number) => {
  if (number) {
    let x = number;
    x = x.toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '')
      lastThree = ',' + lastThree;
    let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
}
export default function Cart_Compo() {
  const items = useSelector(state => state.cart.items);

  const originalPriceTotal = items !== null && items.reduce((amount, item) => item.originalPrice * item.quantity + amount, 0)
  const actualPrice = items !== null && items.reduce((amount, item) => item.price * item.quantity + amount, 0)
  const cartItemsLength = useSelector(state => state.cart.itemsLength)


  return (
    <div className="bg-white">
      {!cartItemsLength ?
        <div className='py-12 lg:py-24 flex items-center justify-center flex-col text-center px-4'>
          <div className='w-48 lg:w-64 mb-6'>
            <img src='/empty-cart-state.svg' alt='empty state' className='w-full h-auto' />
          </div>
          <h3 className='text-2xl lg:text-3xl leading-snug text-gray-900 tracking-tight font-bold mb-4'>
            Your Cart is Empty!
          </h3>
          <div className="max-w-xs lg:max-w-md space-y-1">
            <p className="text-gray-500 text-sm lg:text-base font-medium">
              Before proceeding to checkout, you must add some products to your cart.
            </p>
            <p className="text-gray-500 text-sm lg:text-base font-medium">
              You'll find a lot of interesting products on our homepage.
            </p>
          </div>
          <Link to="/" className="mt-8 px-10 py-3 text-sm font-bold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-all uppercase tracking-wide w-full sm:w-auto shadow-md">
            Go to Shop
          </Link>
        </div>
        :
        <div className="lg:max-w-7xl	px-4 pb-24 pt-4 lg:px-8 sm:px-6 py-16 mx-auto max-w-2xl	">
          <h1 className='lg:text-3xl leading-9 text-gray-900 tracking-tight	font-bold text-3xl mt-4	'>Shopping Cart</h1>
          <form action='/checkout' className='lg:gap-x-12	lg:items-start	lg:grid  lg:grid-cols-12 w-full	mt-8'>
            <section aria-labelledby="cart-heading" className='col-span-7'>
              <h2 id="cart-heading" className='whitespace-nowrapw-px	h-px p-0 overflow-hidden absolute bottom-0 m-1'>Items in your shopping cart</h2>
              <CartItems padding="py-6 sm:py-10" border="true" />
            </section>
            <section aria-labelledby='summary-heading' className='mt-16 lg:sticky lg:inset-y-1/4	 rounded-lg bg-gray-100 shadow-sm	px-4 py-4 sm:p-6 col-span-5	lg:mt-0 lg:p-8'>
              <h2 id="summary-heading" className="text-lg	font-medium text-gray-700">PRICE DETAILS</h2>
              <div className="mt-6">
                <div className='flex justify-between items-center py-4'>
                  <h3 className="text-base text-gray-600	">Price ({cartItemsLength} Items)</h3>
                  <h3 className="text-base font-medium text-gray-900">₹{formatNumber(originalPriceTotal)}</h3>
                </div>

                <div className='flex justify-between items-center border-gray-200	border-t-[1px] py-4'>
                  <div className='flex items-center text-base text-gray-600	'>
                    <span>Discount</span>
                  </div>
                  <h3 className="text-base font-medium text-green-500	">− ₹{formatNumber(originalPriceTotal - actualPrice)}</h3>
                </div>

                <div className='flex justify-between items-center border-gray-200	border-t-[1px] py-4'>
                  <div className='flex items-center text-base text-gray-600	'>
                    <span>Delivery Charges</span>
                    <Link href="#" className="ml-2 flex-shrink-0 text-gray-400	">
                      <span className="whitespace-nowrapw-px	h-px p-0 overflow-hidden absolute bottom-0 m-1">Learn more about how shipping is calculated</span>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" className="h-5 w-5"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.94 6.94a.75.75 0 11-1.061-1.061 3 3 0 112.871 5.026v.345a.75.75 0 01-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 108.94 6.94zM10 15a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd"></path></svg>
                    </Link>
                  </div>
                  <h3 className="text-base font-medium text-gray-900"><span className='text-gray-400 line-through'>₹110</span> <span className='text-green-500'>Free</span></h3>
                </div>

                <div className='flex justify-between items-center border-dashed border-gray-200	border-t-[1px] py-4'>
                  <h3 className="text-lg font-medium text-gray-800">Total Amount</h3>
                  <h3 className="text-lg font-medium text-gray-800">₹{formatNumber(actualPrice)}</h3>
                </div>

              </div>
              <div className="mt-4 pb-3">
                <Link to="/checkout" className="w-full block text-center rounded-md	border-[1px] bg-indigo-600 py-3 text-base font-medium text-white shadow-md" style={{ borderColor: "#0000" }}>Checkout</Link>
              </div>
              <p className="text-sm font-normal text-gray-500 text-center my-4">
                <Link to="/" className="font-medium text-indigo-600 hover:underline inline-flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 me-1 hover:underline"> <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" /> </svg>
                  Continue Shopping</Link>
              </p>
            </section>
          </form>
        </div>
      }
    </div>

  );
}
